import { type Page } from '#shared/api/schema';

export const canConstructorPageChangePattern = (page: Page) =>
    // Созданные пользователем
    !page.alias;
